import { Component, OnInit, Input } from '@angular/core';
import { StaticData } from '../../helpers/static-data'
import { GeneralComunicationService } from 'src/app/services/general-comunication.service';
import { Utilities } from 'src/app/helpers/utilities';
declare var fabric: any;

@Component({
  selector: 'app-user-nav',
  templateUrl: './user-nav.component.html',
  styleUrls: ['./user-nav.component.scss']
})
export class UserNavComponent implements OnInit {

  textoLogin = 'Iniciar sesión';
  viewColors = false;
  @Input() infoUsuario: any = { Usuario: null, Email: "", Nombre: "Usuario NO Autenticado", Empresa: "Empresa" };
  @Input() inSharePoint = false;
  constructor(public utility: Utilities, public comunicationService: GeneralComunicationService) { }

  public NavegarLogin() {
    if (this.textoLogin === 'Iniciar sesión') {
      debugger;
      this.comunicationService.raiseLoginEvent();
    }
    else {
      this.textoLogin = 'Iniciar sesión';
      StaticData.Usuario = null;
      StaticData.Estilos = {};
      StaticData.ConfigPaginas = [];
    }
  }

  public get IsLoged(): any {
    return (StaticData.Usuario != null);
  }

  public GetName() {
    if (StaticData.Usuario)
      return StaticData.Usuario.Usuario;
    else
      return "Usuario NO Autenticado";
  }
  public GetEmail() {
    if (StaticData.Usuario)
      return StaticData.Usuario.Email;
    else
      return "Usuario NO Autenticado";
  }

  SetDatosUsuario() {
    if (StaticData.Usuario) {
      this.infoUsuario.Nombre = StaticData.Usuario.Nombre;
      this.infoUsuario.Email = StaticData.Usuario.Email;
      this.infoUsuario.Empresa = StaticData.Usuario.Empresa;
    }
    else {
      this.infoUsuario = { Usuario: null, Email: "", Nombre: "Usuario NO Autenticado", Empresa: "Empresa" };
    }
  }

  ngOnInit() {

    this.SetDatosUsuario();

    this.comunicationService.receivedNavItemsEvent.subscribe(data => {

      this.SetDatosUsuario();
    })
    this.comunicationService.receivedLoginEvent.subscribe(data => {

      this.SetDatosUsuario();
    })
    this.comunicationService.receivedLogOutEvent.subscribe(data => {
      this.SetDatosUsuario();
    })
  }

  AfterViewInit(){
    var CommandBarElements = document.querySelectorAll(".ms-CommandBar");
    for (var i = 0; i < CommandBarElements.length; i++) {
      new fabric['CommandBar'](CommandBarElements[i]);
    }
  }

  public SetViewColors() {
    this.viewColors = !this.viewColors;
  }


  public ViewThemeCustomizationComponent() {

    debugger;
    const config = this.utility.GetConfigWindow('personalizar Tema');
    let isNew: boolean = false;
    let windowModel: any = {


    };

    this.utility.VerModalComponente('ThemeCustomizationComponent', windowModel, config).then(dataResultOnClose => {
      if (dataResultOnClose.dialogResult && dataResultOnClose.dialogResult == true) {

        debugger;

      }
      else {

      }
    });
  }

}
